import React from 'react'
import styled from 'styled-components'

import { COLOR_GREEN } from '../theme'
import PageInfo from './PageInfo'

const Content = styled.div`
  color: rgba(255, 255, 255, .7);

  a {
    color: ${COLOR_GREEN};
  }

  p {
    margin-bottom: 2rem;
  }

  h3, h4 {
    color: rgba(255, 255, 255, 1);
  }

  h4 {
    margin-bottom: 1rem;
  }

  section {
    margin-bottom: 4rem;
  }

  ol {
    margin-top: 1rem;
  }

  li {
    margin-bottom: 1rem;
  }
`

export const LegalPage = ({ title, children, isNarrow = true }) => {
  return (
    <PageInfo
      isNarrow={isNarrow}
      title={title}
    >
      <Content>
        {children}
      </Content>
    </PageInfo>
  )
}

export default LegalPage
